import React from "react";
import LoadingView from "@/components/ui/loading-view/LoadingView";

const GoogleAccountSettingsGate = React.lazy(
  () => import("./GoogleAccountSettings.gate")
);

const GoogleAccountSettingsLoadable = () => (
  <React.Suspense fallback={<LoadingView />}>
    <GoogleAccountSettingsGate />
  </React.Suspense>
);

export default () => <GoogleAccountSettingsLoadable />;
